module.exports = "/static/assets/e8b628b89467100b7b47fdf1f2fd70dc.png";